<div class="advanced-settings">
  <div class="content">
    <div class="tabs-setting">
      <a routerLink="/advanced-settings/profile" routerLinkActive="active">edit Profile</a>
      <a routerLink="/advanced-settings/verify" routerLinkActive="active">verify</a>
    </div>
    <!-- <div class="content__title">Verify</div> -->
    <div class="content__box verify-content-shepherd">
      <div (click)="!userInfo?.isEmailVerify ? openModal(VerifyEmailOtp) : ''" class="btn-verified" [class.green]="userInfo?.isEmailVerify">
        <i class="fa fa-envelope icon"></i>
        <div>
          <div class="name">Email</div>
          <div class="meta">{{ userInfo?.isEmailVerify ? "" : "Not" }} Verified</div>
        </div>
        <i
          class="fa fa-check-circle"
          [ngStyle]="{
            color: userInfo?.isEmailVerify ? 'green' : 'red'
          }"
        ></i>
      </div>

      <div class="btn-verified" [class.green]="userInfo?.isVerified" (click)="userInfo?.isVerified ? '' : (showVerificationTelegram = true)">
        <i class="fa-brands fa-whatsapp icon"></i>
        <div>
          <div class="name">WhatsApp</div>
          <div class="meta">{{ userInfo?.isVerified ? "" : "Not" }} Verified</div>
        </div>
        <i
          class="fa fa-check-circle"
          [ngStyle]="{
            color: userInfo?.isVerified ? 'green' : 'red'
          }"
        ></i>
      </div>

      <div class="verification" *ngIf="showVerificationTelegram" [ngClass]="{ active: showVerificationTelegram }">
        <span (click)="showVerificationTelegram = false; isReset = false">
          <i class="fa-solid fa-times" style="color: black !important"></i>
        </span>
        <div>
          <div style="display: flex; justify-content: center; align-items: center">
            <mat-label>Enter OTP</mat-label>
            <mat-form-field style="width: 100%; display: flex; align-items: center; gap: 10px">
              <input matInput formControlName="otp" maxlength="6" style="text-align: center" class="form-control" (change)="onChangeOtp($event)" required />
              <button mat-raised-button color="primary" (click)="sendOtp()" [disabled]="isLoading" style="margin-bottom: 10px" class="btn btn-purple">OTP</button>
            </mat-form-field>
          </div>

          <mat-form-field style="width: 100%; display: flex; flex-direction: column">
            <mat-label class="mb-2 mt-2">Enter 4 Digit Passcode</mat-label>
            <input matInput formControlName="otp" maxlength="4" style="text-align: center" class="form-control mb-2" (change)="onChangePasscode($event)" required />
          </mat-form-field>
          <div style="color: red">{{ otpError }}</div>
          <button (click)="verifyOtp()" [disabled]="isLoading" class="btn btn-purple mt-2">Verify</button>
        </div>
      </div>
    </div>

    <div class="content__box verify-content-shepherd">
      <div (click)="userCard ? openModal(VerifyCardOtp) : ''" class="btn-verified" [class.green]="userCard">
        <i class="fa fa-credit-card icon"></i>
        <div>
          <div class="name">Card</div>
          <div class="meta">{{ userCard ? "" : "Not" }} Verified</div>
        </div>
        <i
          class="fa fa-check-circle"
          [ngStyle]="{
            color: userCard ? 'green' : 'red'
          }"
        ></i>
      </div>
    </div>
  </div>
</div>

<ng-template #VerifyEmailOtp let-modal>
  <div class="my-modal__close" (click)="modal.dismiss('Cross click')">
    <i class="fa-solid fa-times"></i>
  </div>
  <div class="my-modal__body">
    <h2 class="title">Email Verification</h2>
    <label class="input">
      <input class="input__field" type="email" placeholder=" " [(ngModel)]="email" />
      <span class="input__label">Email</span>
    </label>
    <label class="input">
      <button class="btn btn-dark btn-otp" (click)="sendEmailOtp()">
        Send OTP<span *ngIf="delaySendOTP > 0" class="ml-2">({{ delaySendOTP }})</span>
      </button>
      <input class="input__field" placeholder=" " type="text" name="selectedMemberPassword" pattern="\d*" maxlength="6" autofocus [(ngModel)]="selectedOTP" required />
      <span class="input__label" (click)="sendEmailOtp()">Enter OTP</span>
    </label>
    <p class="error-message p-0" *ngIf="invalidOtp">{{ invalidOtp }}</p>
    <button class="my-button-3" (click)="verifyEmailOtp()">Verify <i class="fa fa-thumbs-up" aria-hidden="true"></i></button>
  </div>
</ng-template>

<ng-template #VerifyCardOtp let-modal>
  <div class="my-modal__close" (click)="modal.dismiss('Cross click')">
    <i class="fa-solid fa-times"></i>
  </div>
  <div class="my-modal__body">
    <h2 class="title">Remove Card</h2>

    <br />
    <br />
    <br />
    <button class="my-button-3 right" (click)="handleRemoveCard()">Remove card <i class="fa fa-thumbs-up" aria-hidden="true"></i></button>
  </div>
</ng-template>
